import axios from 'axios';
import { displayLanguage } from './translations';

declare var APP_URL: any;

export default function () {
  // @ts-ignore
  var platform = Office.context.platform;
  return axios.get(`${APP_URL}/updates-${displayLanguage}.json?platform=${platform}`)
    .then((response) => {
      if (!response.data) return;

      setTimeout(() => {
        Office.context.document.settings.saveAsync(() => { /* noop */ })
      }, 10);

      return response.data.filter((message) => {
        var result = Office.context.document.settings.get('message_read_' + message.id);
        if (result) return false;

        Office.context.document.settings.set('message_read_' + message.id, false);

        return true;
      });

    }, (error) => {
      console.log('problem: ', error)
    })
}



// WEBPACK FOOTER //
// ./util/fetch-messages.tsx